import React from 'react'
import { connect } from 'react-redux'
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'
import taGrad01 from '../../images/ta-grad-01.png'
import taGrad02 from '../../images/ta-grad-02.png'
import taGrad03 from '../../images/ta-grad-03.png'
import taGrad04 from '../../images/ta-grad-04.png'
import { usersGetDetailAsync } from '../../actions/users.js'
import { accesslog, translate } from '../../helpers/global.js'
import { Link } from 'react-router-dom'
import { getWeeklyDemoDataAsync } from '../../actions/global';

class TaGrad extends React.Component {

  constructor(props) {
    super(props);
  }
	async componentDidMount() {
		window.scrollTo(0, 0)
    if (!this.props.weeklyDemoData || !this.props.weeklyDemoData.webinar_link) {
      await this.props.getWeeklyDemoDataAsync();
    }
	}

  render() {
    const { globalGetLanguages, weeklyDemoData } = this.props;

    return (
			<div id="homepage">
        <HeaderNewClear isOnStatusFor="is-on" />
        <div className="section-top-solution relative bg-gray" style={{
          position: 'relative',
          paddingTop: '120px',
        }}>
          <div className="gray-curve-bottom-right"></div>
          <section className='flex-container' style={{zIndex: '2'}}>
            <div className='flex-item-left' style={{ flex:'55%' }}>
              <div className='vertical-item--center'>
                <div className="sec-desc">
                  <h1>
                    Identifying the Right Talent for Graduate Programs
                  </h1>
                  <p>
                    Graduate Programs Unbounded with Scale, Speed & Reach
                  </p>
                  <br />
                  <p className='text-normal-2'>
                    In the past, graduate hiring teams were often constrained and only partnered with a few universities.  Now with ASTRNT applications can be open to candidates from anywhere across the globe. More applicants means higher potential talent coming into your organisation. ASTRNT helps you bring structure, clarity, and speed to your early talent hiring program. Make better decisions, much faster.
                  </p>
                  <br />
                  <div className={`ban-link`} style={globalGetLanguages == 'id' ? {margin: '0'} : {margin: '8px 0 0'}}>
                    <a onClick={() => {
                      document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                      accesslog('talent-acquisition/graduate', 'button_talk_to_an_expert');
                    }} className="request-demo-logged">{translate(globalGetLanguages,'HOMEPAGE_BUTTON_REQUEST_DEMO')}</a>
                    <a href={weeklyDemoData.webinar_link} target="_blank" className={`btn btn-secondary-red${weeklyDemoData.webinar_link != null ? '' : ' hide'}`}
                      onClick={() => accesslog('talent-acquisition/graduate', 'button_register_for_demo')}
                    >Register for Demo</a>
                  </div>
                </div>
              </div>
            </div>
            <div className='flex-item-right flex-container flex-end align-items-center' style={{ flex:'45%' }}>
              <div className='horizontal-item--center'>
                <img className='img-100' src={taGrad01} />
              </div>
            </div>
          </section>
        </div>
        <div className="section-white" style={{overflow: 'hidden'}}>
          <section className='flex-container' style={{zIndex: '2'}}>
            <div className='flex-item-right flex-container flex-end align-items-center flex-padding-1'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={taGrad02} />
              </div>
            </div>
            <div className='flex-item-left flex-padding-1 p-l-80'>
              <div className='vertical-item--center'>
                <h1 className='title-2'>
                  Understand Who They Are Before You Train Them
                </h1>
                <p className='sub-title-1'>
                  Fresh graduates bring potential, not portfolios. But with large volumes and limited data, it’s hard to know who to shortlist, where they fit, or whether they align with your values.
                </p>
                <p className='sub-title-1 m-t-25'>
                  Common challenges:
                </p>
                <ul className='list-1'>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        Difficult to compare across universities or backgrounds
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        CVs and GPA don’t show soft skills or mindset
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        Limited time and resources to screen each candidate properly
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        Unclear placement fit within teams or functions
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>
        <div className="section-white" style={{overflow: 'hidden'}}>
          <section className='flex-container' style={{zIndex: '2'}}>
            <div className='flex-item-left p-r-40'>
              <div className='vertical-item--center'
                style={{
                  padding: '0 40px',
                }}
              >
                <h1 className='title-2'>
                  How ASTRNT Helps You Run Graduate Programs Better
                </h1>
                <p className='sub-title-1 text-justify'>
                  ASTRNT gives you a consistent and structured way to run your early talent program from application to final shortlist. With a combination of interviews, assessments, and AI scoring, you can focus on what matters: potential, mindset, and role fit.
                </p>
                <ul className='list-1 m-t-25'>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        All candidates go through the same structured experience
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        Assess traits like communication, learning ability, and alignment with values
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        Get placement suggestions based on assessment
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        Manage large-scale intakes from a single dashboard
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className='flex-item-right flex-container flex-end align-items-center'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={taGrad03} />
              </div>
            </div>
          </section>
        </div>
        <div className="section-white bg-gray center"
          style={{
            textAlign: '-webkit-center',
            minHeight: '366px',
            padding: '56px 0',
            position: 'relative',
          }}
        >
          <div className='gray-triangle-bottom-right'>
            <div className='gray-small-triangle-bottom-right'></div>
          </div>
          <div>
            <h1 className='title-1'>
              Select Your Future Talent Efficiently
              <br />
              with Confidence
            </h1>
            <p style={{
              margin: '20px 0',
            }}>
              Graduate programs are your long-term investment. ASTRNT helps you quickly reach a much larger pool
              <br />
              of high potential talent and select with confidence, fast.
            </p>
            <div>
            
            <div className="ban-text-start-demo">
              <div className={`ban-link`}>
                <Link onClick={() => {
                  document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                  accesslog('talent-acquisition/graduate', 'button_talk_to_an_expert');
                }} className="try">Talk to an Expert</Link>
                <a href={weeklyDemoData.webinar_link} target="_blank" className={`request-demo-logged${weeklyDemoData.webinar_link != null ? '' : ' hide'}`}
                  onClick={() => accesslog('talent-acquisition/graduate', 'button_register_for_demo')}
                >Register for Demo</a>
              </div>
            </div>

            </div>
          </div>
        </div>
        <FooterNew />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
	return {
    globalGetLanguages:state.globalGetLanguages,
    user: state.user,
    weeklyDemoData: state.weeklyDemo.weeklyDemoData 
	}
}

const mapDispatchToProps = (dispatch) => {
  return {
    usersGetDetailAsync: (user) => dispatch(usersGetDetailAsync(user)),
    getWeeklyDemoDataAsync: () => dispatch(getWeeklyDemoDataAsync())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TaGrad)
